import { render, staticRenderFns } from "./ProDecks.vue?vue&type=template&id=ddbd4c04&scoped=true"
import script from "./ProDecks.vue?vue&type=script&lang=ts"
export * from "./ProDecks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbd4c04",
  null
  
)

export default component.exports